// extracted by mini-css-extract-plugin
export default {"backButton":"Create_backButton__BsD4z","btn":"Create_btn__pYhed"};